
import {Component, Vue} from "vue-property-decorator";
import { Getter } from "vuex-class";
import Notification from "@/components/Notification.vue";
@Component({
    components: {
        Notification,
    },
})

export default class OptionNotification extends Vue {

    @Getter private currentUser: any;

    private relays: object[] = [];

    public mounted(): void {
        this.getRelays();
    }

    private getRelays(): Promise<void> {
        const pagination = {
            userId: this.currentUser.id,
        };
        return this.$store.dispatch("relays/getAll", {query: pagination})
        .then((res) => {
            this.relays = res.relays;
        })
        .catch((err) => {
            this.$store.commit("alerts/displayError", {
                msg: err,
            });
        });
    }
}
